import config from '../config/index'
import router from '@/router'
import Cookies from 'js-cookie';
import store from '@/store'
const pageMap = config.pageMap
// const isThird = Cookies.get("isThird")

var scrollTimer = null

var page = {
    // 切换页面，并错误提示
    turnPage: (message, platId) => {
        if (message) {
            alert(message)
        }
        // if (isThird == 1) {
            Cookies.set('userToken'+store.getters.platId,"");
            store.commit('setToken', "")
            if (pageMap[platId]) {
                var url = pageMap[platId]
                window.location.href = url
            }else{
                router.push({
                    path: "/userReg",
                    query: {
                        platId: store.getters.platId
                    }
                })
            }
        // }else{
        //     router.push({
        //         path: "/userReg"
        //     })
        // }
    },
    // 确定导航tab页，是否show nav
    showNav: path => {
        switch (path) {
            case '/':
                return true;
            case '/session':
                return true;
            case '/contacts':
                return true;
            case '/room':
                return true;
            case '/general':
                return true;
            default:
                return false
        }
    },
    // 滚动聊天列表到底部
    scrollChatListDown: (id, pos, initCount) => {
        let dom = document.getElementById(id)
        if (!dom) {
            return
        }
        let maxCount = 5
        initCount = initCount || 1
        if (typeof pos !== 'number') {
            pos = Math.max(dom.scrollHeight - dom.clientHeight, 888888)
        }
        dom.scrollTop = pos
        if ((dom.scrollTop < pos) && (initCount < maxCount)) {
            clearTimeout(scrollTimer)
            scrollTimer = setTimeout(() => {
                initCount++
                page.scrollChatListDown(pos, initCount)
            }, 200)
        }
    },
    getChatListHeight: (id) => {
        return document.getElementById(id).scrollHeight
    },
    getChatListScroll: (id) => {
        return document.getElementById(id).scrollTop
    },
}

export default page



// WEBPACK FOOTER //
// ./src/utils/page.js